"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightText = exports.splitTextBySubstring = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const BoldText = styled_components_1.default.span({
    fontWeight: 'bold',
});
function splitTextBySubstring(text, substring) {
    const lowerText = text.toLocaleLowerCase();
    const lowerSubstring = substring.toLocaleLowerCase();
    const start = lowerText.indexOf(lowerSubstring);
    const end = start + lowerSubstring.length;
    if (start < 0) {
        return null;
    }
    return [
        text.substring(0, start),
        text.substring(start, end),
        text.substring(end),
    ];
}
exports.splitTextBySubstring = splitTextBySubstring;
const HighlightText = props => {
    const { text, substring } = props;
    const splitResult = splitTextBySubstring(text, substring);
    if (!splitResult) {
        return react_1.default.createElement(react_1.default.Fragment, null, text);
    }
    const [before, found, after] = splitResult;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        before,
        react_1.default.createElement(BoldText, null, found),
        after));
};
exports.HighlightText = HighlightText;
//# sourceMappingURL=index.js.map